"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignIn = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SignIn = function SignIn(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55556 7.55556C7.55556 5.03959 9.59515 3 12.1111 3C14.6271 3 16.6667 5.03959 16.6667 7.55556C16.6667 10.0715 14.6271 12.1111 12.1111 12.1111C9.59515 12.1111 7.55556 10.0715 7.55556 7.55556ZM14.6667 7.55556C14.6667 6.14416 13.5225 5 12.1111 5C10.6997 5 9.55556 6.14416 9.55556 7.55556C9.55556 8.96695 10.6997 10.1111 12.1111 10.1111C13.5225 10.1111 14.6667 8.96695 14.6667 7.55556ZM20.2173 18.0078C20.1053 15.5914 18.1107 13.6667 15.6667 13.6667H8.55556L8.3411 13.6716C5.92471 13.7836 4 15.7781 4 18.2222V20L4.00673 20.1166C4.06449 20.614 4.48716 21 5 21C5.55228 21 6 20.5523 6 20V18.2222L6.00544 18.0542C6.09196 16.7211 7.20062 15.6667 8.55556 15.6667H15.6667L15.8347 15.6721C17.1678 15.7586 18.2222 16.8673 18.2222 18.2222V20L18.2289 20.1166C18.2867 20.614 18.7094 21 19.2222 21C19.7745 21 20.2222 20.5523 20.2222 20V18.2222L20.2173 18.0078Z"
  }));
};

exports.SignIn = SignIn;